import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { SelectedListStyled } from './SelectedList.styled';

type Props = {
  items: Record<string, any>[];
  onDeleteItems: (itemsDeleted: string) => void;
  onModalOpen: () => void;
  showCount?: boolean;
  title: string;
};

function SelectedList({ items, onDeleteItems, onModalOpen, showCount = false, title }: Props) {
  const { formatMessage } = useIntl();
  return (
    <SelectedListStyled className="selectedList">
      <div className="selectedList__header fontSemiBold">
        <div className="selectedList__titleContainer">
          <div className="selectedList__title">{title}</div>
          {showCount && <div className="selectedList__count">{items.length}</div>}
        </div>
        <ButtonUI
          className="selectedList__button"
          id="selectedList-button"
          onClick={onModalOpen}
          shape="link"
          size="medium"
          text={formatMessage({
            defaultMessage: 'Edit Selection',
            id: 'targeting.audienceTargeting.audienceProfile.previousCampaign.list.editSelectionButton'
          })}
          type="secondary"
        />
      </div>
      {items.map((item, i) => (
        <div className="selectedList__item" key={i}>
          <div className="selectedList__name fontSemiBold">{item.name}</div>
          <ButtonUI
            className="selectedList__button"
            icon="fa-solid fa-xmark-large"
            id={`selectedList-button-${item._id}`}
            onClick={() => onDeleteItems(item._id)}
            shape="link"
            size="small"
            type="secondary"
          />
        </div>
      ))}
    </SelectedListStyled>
  );
}

export default SelectedList;
